export default function Tooltip({ message, children }) {
  return (
  <div className="group relative flex justify-center items-center">
    {children}
    <span className="absolute top-16 scale-0 opacity-0 transition-all rounded bg-gray-600 p-2 text-s text-white group-hover:scale-100 group-hover:opacity-50 group-hover:top-24">{message}</span>
  </div>
  )
}